export const toLowerAndTrim = (str: string | undefined | null) => str?.toLowerCase().trim() || '';
